export default
{
    "GLOBAL_LOADER":"GLOBAL_LOADER",
    "LOADER_PROPOSAL_BUILDER":"LOADER_PROPOSAL_BUILDER",
    "LOADER_MASTER_INPUT":"LOADER_MASTER_INPUT",
    "FETCH_USER_INFO":"FETCH_USER_INFO"
}